import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import WebLayout from './shared/layout/layout.component';
import Index from './pages/index.component';
import BookNow from './pages/bookNow.component';
import JoinUs from './pages/joinUs.component';
import ContactUs from './pages/contactUs.component';
import ServiceFinder from './pages/serviceFinder.component';
import Services from './pages/services.component';
import Terms from './pages/terms.component';
import PaymentOptions from './pages/paymentOptions.component';
import AboutUs from './pages/aboutUs.component';
import FAQs from './pages/faq.component';
import Blogs from './pages/blogs.component';
import BlogDetail from './pages/blogDetail.component';
import VehicleDetail from './pages/vehicleDetail.component';
import MyAccount from './pages/myAccount.component';
import ServiceLanding from './pages/serviceLanding.component';
import { FEATURE_FLAGS } from './config/featureFlags';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<WebLayout />}>
          <Route path="/" element={
            <Index />
          }></Route>
          <Route path='/services' element={
            <Services />
          }></Route>
          <Route path="/book-now" element={
            <BookNow />
          }></Route>
          <Route path="/join-us" element={
            <JoinUs />
          }></Route>
          <Route path="/contact" element={
            <ContactUs />
          }></Route>
          <Route path="/services/:serviceType" element={
            <ServiceLanding />
          }></Route>
          <Route path="/services/:serviceType/:location" element={
            <ServiceFinder />
          }></Route>
          <Route path='/terms-and-conditions' element={<Terms />}></Route>
          <Route path='/payment-options' element={<PaymentOptions />}></Route>
          <Route path='/about' element={<AboutUs />}></Route>
          <Route path='/FAQs' element={<FAQs />}></Route>
          <Route path='/blogs' element={FEATURE_FLAGS.ENABLE_EXTRA_FEATURES ? <Blogs /> : <Navigate to="/" replace />}></Route>
          <Route path='/blogs/:slug' element={FEATURE_FLAGS.ENABLE_EXTRA_FEATURES ? <BlogDetail /> : <Navigate to="/" replace />}></Route>
          <Route path='/services/:serviceType/:location/:slug' element={<VehicleDetail />}></Route>
          <Route path='/my-account' element={FEATURE_FLAGS.ENABLE_EXTRA_FEATURES ? <MyAccount /> : <Navigate to="/" replace />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
